// Custom upload adapter so we can use the Node/Express API endpoint
class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return new Promise((resolve, reject) => {
      this._sendRequest(resolve, reject);
    });
  }

  _sendRequest(resolve, reject) {
    this.loader.file.then((file) => {
      const formData = new FormData();
      formData.append("file", file);

      // Upload data
      fetch(`${process.env.REACT_APP_API_URL}/files`, {
        method: "POST",
        credentials: "include",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            console.log("Successfully Uploaded Image");
            const fileName = data.data[0].thisFileName;
            // Return file URL
            resolve({
              default: `${process.env.REACT_APP_FILE_URL}/${fileName}`,
            });
          } else {
            reject(data.error);
          }
        })
        .catch((e) => console.log(e));
    });
  }
}
//
// The onReady function to run in each instance of CKEditor
// This loads the custom UploadAdapter class
const onReadyCKE = (editor) => {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new UploadAdapter(loader);
  };
};

const CKEconfig = (placeholder) => {
  return {
    toolbar: {
      items: [
        "heading",
        "|",
        "alignment",
        "outdent",
        "indent",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "bold",
        "underline",
        "italic",
        "blockQuote",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "imageInsert",
        "insertTable",
        "mediaEmbed",
        "codeBlock",
        "htmlEmbed",
        "undo",
        "redo",
      ],
    },
    mediaEmbed: {
      previewsInData: true,
    },
    image: {
      toolbar: [
        "imageStyle:full",
        "imageStyle:side",
        "|",
        "imageTextAlternative",
      ],
    },
    placeholder,
  };
};

export { onReadyCKE, CKEconfig };
